import { createContext, useContext } from "react";

///
/// Interfaces
///

export interface IAgTechDialog {
    dialogId: string
}

///
/// Dialog Context
///

export type AgTechDialogContext = {
    closeDialog: (e: React.MouseEvent<HTMLElement> | null) => void
}

export const DialogContext = createContext<AgTechDialogContext>({
    closeDialog: (e: React.MouseEvent<HTMLElement> | null) => {
        console.warn('DialogContext.closeDialog() not implemented');
    }
});

export const useDialogContext = () => useContext(DialogContext);

///
/// Dialog Events
///

export type AgTechDialogEventHandlers = {
    onDialogSubmitted?: () => Promise<void>,
    onDialogClosed?: () => Promise<void>
}